import { gql } from '@apollo/client'

export const updateAdvisorPermissions = gql`
  mutation UpdateAdvisorPermissions($input: UpdateAdvisorPermissionsInput!) {
    updateAdvisorPermissions(input: $input) {
      advisorId
      rbacUserRoleId
      permissions {
        menuGivingActivity
        menuInvestmentActivity
        menuContribute
        menuDocuments
        menuGrants
      }
    }
  }
`

export const removeAdvisorFromFund = gql`
  mutation RemoveAdvisorFromFund($input: RemoveAdvisorInput!) {
    removeAdvisorFromFund(input: $input)
  }
`
